module.exports = __webpack_public_path__ + "static/media/Logo.550365a1.svg";